import React from 'react';

const FullLockWithBackground = () => (
  <svg
    width="110"
    height="110"
    viewBox="0 0 110 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1123_29277"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="110"
      height="110"
    >
      <path
        d="M78.3449 106.212C98.2639 99.4655 109.878 84.6617 110 55C109.878 25.3383 98.2639 10.5345 78.3449 3.78835C71.6091 1.50971 63.6427 -2.14168e-06 55 -2.54096e-06C46.3517 -2.94051e-06 38.3853 1.50971 31.6551 3.78835C11.736 10.5345 0.122031 25.3383 -2.27466e-06 55C0.122029 84.6617 11.736 99.4655 31.6551 106.212C38.3853 108.49 46.3517 110 55 110C63.6427 110 71.6091 108.49 78.3449 106.212Z"
        fill="#4369EE"
      />
    </mask>
    <g mask="url(#mask0_1123_29277)">
      <path
        d="M78.3449 106.212C98.2639 99.4655 109.878 84.6617 110 55C109.878 25.3383 98.2639 10.5345 78.3449 3.78835C71.6091 1.50971 63.6427 -2.14168e-06 55 -2.54096e-06C46.3517 -2.94051e-06 38.3853 1.50971 31.6551 3.78835C11.736 10.5345 0.12203 25.3383 -2.27466e-06 55C0.122028 84.6617 11.736 99.4655 31.6551 106.212C38.3853 108.49 46.3517 110 55 110C63.6427 110 71.6091 108.49 78.3449 106.212Z"
        fill="#4369EE"
      />
      <path
        d="M70.8883 95.1502C92.8663 88.7896 105.681 74.8317 105.815 46.865C105.681 18.8982 92.8663 4.94033 70.8883 -1.42031C63.4563 -3.56875 54.6665 -4.99219 45.1304 -4.99219C35.5881 -4.99219 26.7983 -3.56875 19.3724 -1.42031C-2.60552 4.94033 -15.42 18.8982 -15.5547 46.865C-15.42 74.8317 -2.60553 88.7896 19.3724 95.1502C26.7983 97.2987 35.5881 98.7221 45.1304 98.7221C54.6665 98.7221 63.4563 97.2987 70.8883 95.1502Z"
        fill="#1F47D3"
      />
    </g>
    <path
      d="M46.6875 48.5908V40.4028C46.6875 35.8807 50.3534 32.2148 54.8755 32.2148C59.3976 32.2148 63.0634 35.8807 63.0634 40.4028V48.5908"
      stroke="white"
      strokeWidth="4.09398"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="38.5"
      y="47.9082"
      width="32.7519"
      height="30.0226"
      rx="6.14098"
      fill="white"
    />
  </svg>
);

export default FullLockWithBackground;
